import { GlobalContext } from "global/context/Provider";
import { useContext, useEffect, useState } from "react";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import {
  BodyContainerP5,
  ButtonP5,
  CardOrden,
  ContainerP5,
  ContainerSinTurno,
  RefreshBox,
} from "./localStyle";
import { showToaster } from "global/context/action/toaster/toaster";
import { wsGetPDFOrdenEstudio } from "_+_Portal/_-_Autocheckin/context/action/ordenesDigitales";
import { base64toBlob } from "global/utils/base64toBlob";
import PdfIcon from "_+_Portal/assets/images/generico/PdfIcon";
import camelize from "global/utils/camelize";
import {
  setAltaOrdenDigitalEstudio,
  setFlgVolverOrdenDigitalEstudio,
  setMedicoSolicitante,
  wsGetGrupoByIdOrden,
  wsGetOrdenDigitalEstudio,
} from "_+_Portal/context/Actions/ordenDigital/ordenDigital";
import { PortalContext } from "_+_Portal/context/Provider";
import { useHistory } from "react-router";
import { FaSyncAlt } from "react-icons/fa";
import {
  setAltaTurnoOrdenDigital,
  wsGetLabOrdenDigital,
} from "_+_Portal/context/Actions/labOrdenDigital/labOrdenDigital";
import { wsGetPDFOrdenDigital } from "_+_Portal/context/Actions/pdfOrdenDigital/pdfOrdenDigital";
import fechaTurnoFormat from "global/utils/fechaTurnoFormat";
import { wsGetLaboCentros } from "_+_Portal/context/Actions/laboGrupo/laboGrupo";
import {
  setBuscarTurnoLabo,
  wsGetLaboTurnos,
} from "_+_Portal/context/Actions/turnos/laboTurnos";
import { editaTurnosDisponibles } from "_+_Portal/context/Actions/turnos/turnosDisponibles";
import { showModal, hideModal } from "_+_Portal/context/Actions/modal/modal";
import ScrollArrows from "_+_Portal/components/Genericos/ScrollArrows/ScrollArrows";
import AlertIconFilled from "_+_Portal/assets/images/generico/AlertIconFilled";
import { getLocalStorage, getSessionStorage } from "global/utils/safeJsonParse";
import { mismoCentro } from "global/utils/idCentro";

const OrdenesDigitales = () => {
  // -------------------------  useContex  ----------------------------
  const { pasoDispatch } = useContext(AutocheckContext);
  const {
    ordenDigitalDispatch,
    laboGrupoDispatch,
    laboTurnosDispatch,
    labOrdenDigitalDispatch,
    turnosDisponiblesState,
    turnosDisponiblesDispatch,
    modalDispatch,
  } = useContext(PortalContext);
  const { toasterDispatch } = useContext(GlobalContext);
  // -------------------------  useContex  ----------------------------

  // -------------------------  constants  ----------------------------
  const history = useHistory();
  let getOrdenes = sessionStorage.getItem("getOrdenes");
  const centroQR = sessionStorage.getItem("centroID");
  const idTerminal = getLocalStorage("idTerminal");
  // -------------------------  constants  ----------------------------

  // -------------------------  useStates  ----------------------------
  const [ordenesList, setOrdenesList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingPDF, setLoadingPDF] = useState(false);
  // -------------------------  useStates  ----------------------------

  // -------------------------  funciones  ----------------------------
  const handleClickButton = (item) => {
    // Muestra la orden: en mobile abre nueva pestaña; en tablet/desktop, modal PDF
    setLoadingPDF(true);
    const isMobile = window.innerWidth < 768;

    // Prioridad: si viene una URL (linkPdfRcta), abrirla directamente
    // - En mobile abre nueva pestaña
    // - En desktop/tablet abre visor modal con PDFViewer
    if (
      item?.linkPdfRcta &&
      typeof item?.linkPdfRcta === "string" &&
      item.linkPdfRcta.trim() !== ""
    ) {
      const url = item.linkPdfRcta.trim();
      try {
        if (isMobile) {
          const newWindow = window.open(url, "_blank");
          if (!newWindow) {
            showToaster(
              {
                texto:
                  "Debes habilitar las ventanas emergentes en tu navegador.",
                tipo: "warning",
              },
              "centroArriba",
            )(toasterDispatch);
          }
        } else {
          showModal(
            "Genericos/PDFViewer/PDFViewer",
            {
              url: url,
              titulo: "Orden digital",
              dissmiss: () => hideModal()(modalDispatch),
            },
            [],
            "centro",
            true,
          )(modalDispatch);
        }
      } catch (error) {
        showToaster(
          { texto: "Error al abrir el documento", tipo: "danger" },
          "centroArriba",
        )(toasterDispatch);
      } finally {
        setLoadingPDF(false);
      }
      return;
    }

    const onSuccess = (data, item) => {
      // Normaliza la respuesta: puede venir como base64 (string) o como Blob o { blob }
      const getBlobAndBase64 = async (input) => {
        if (input && input.blob instanceof Blob) {
          const blob = input.blob;
          const base64 = await blobToBase64(blob);
          return { blob, base64 };
        }
        if (input instanceof Blob) {
          const blob = input;
          const base64 = await blobToBase64(blob);
          return { blob, base64 };
        }
        if (typeof input === "string") {
          const blob = base64toBlob(input, "application/pdf");
          return { blob, base64: input };
        }
        return { blob: null, base64: null };
      };

      const blobToBase64 = (blob) =>
        new Promise((resolve, reject) => {
          try {
            const reader = new FileReader();
            reader.onloadend = () => {
              const result = reader.result || "";
              const str = typeof result === "string" ? result : "";
              const commaIdx = str.indexOf(",");
              resolve(commaIdx >= 0 ? str.substring(commaIdx + 1) : str);
            };
            reader.onerror = (e) => reject(e);
            reader.readAsDataURL(blob);
          } catch (e) {
            reject(e);
          }
        });

      const run = async () => {
        const { blob } = await getBlobAndBase64(data);
        if (!blob) {
          showToaster(
            {
              texto: "No se pudo generar el documento.",
              tipo: "danger",
            },
            "centroArriba",
          )(toasterDispatch);
          setLoadingPDF(false);
          return;
        }
        const blobUrl = URL.createObjectURL(blob);
        // Si es terminal abro el modal con la receta
        if (idTerminal) {
          showModal(
            "Genericos/PDFViewer/PDFViewer",
            {
              url: blobUrl,
              titulo: "Orden digital",
              dissmiss: () => hideModal()(modalDispatch),
            },
            [],
            "centro",
            true,
          )(modalDispatch);
        } else {
          // Si es mobile abro la receta en una nueva pestaña
          const nuevaVentana = window.open("", "_blank");
          if (nuevaVentana) {
            nuevaVentana.location.href = blobUrl;
            setTimeout(() => URL.revokeObjectURL(blobUrl), 5000);
          } else {
            showToaster(
              {
                texto: "El navegador bloqueó la apertura de la ventana.",
                tipo: "danger",
              },
              "centroArriba",
            )(toasterDispatch);
          }
        }
        setLoadingPDF(false);
      };

      run();
    };

    const onError = () => {
      showToaster(
        { texto: "Error al generar la orden.", tipo: "danger" },
        "centroArriba",
      )(toasterDispatch);
      setLoadingPDF(false);
    };

    if (item?.idLabProtAgenda) {
      wsGetPDFOrdenDigital(item.id, (isCorrect, data) => {
        if (isCorrect) onSuccess(data);
        else onError();
      })(labOrdenDigitalDispatch);
    } else {
      wsGetPDFOrdenEstudio(item.id, (isCorrect, data) => {
        if (isCorrect) onSuccess(data);
        else onError();
      });
    }
  };

  const verAgendasDisponibles = (item) => {
    setLoadingPDF(true);
    if (!item?.requiereTurno) {
      setFlgVolverOrdenDigitalEstudio(true)(ordenDigitalDispatch);
    }
    setAltaOrdenDigitalEstudio(item.id)(ordenDigitalDispatch);
    setMedicoSolicitante(item.idMedSolicitante)(ordenDigitalDispatch);
    wsGetGrupoByIdOrden(item.id, (isCorrect, data) =>
      nextStep(isCorrect, data, item),
    )(ordenDigitalDispatch);
  };

  const asociarTurnoLabo = (data) => {
    // setPaso("EstudiosLabo")(pasoDispatch);
    setLoadingPDF(true);
    const fecha = fechaTurnoFormat();
    const idGrupoTurnoLaboGeneral = 5;
    setFlgVolverOrdenDigitalEstudio(true)(labOrdenDigitalDispatch);
    setAltaTurnoOrdenDigital(data?.idprotocolo)(labOrdenDigitalDispatch);
    setBuscarTurnoLabo(true)(laboTurnosDispatch);
    wsGetLaboCentros((isCorrect, dataCentros) => {
      if (isCorrect) {
        wsGetLaboTurnos(
          fecha,
          -1,
          -1,
          idGrupoTurnoLaboGeneral,
          -1,
          (isCorrect, data) => nextStepTurnoLabo(isCorrect, data, dataCentros),
        )(laboTurnosDispatch);
      } else {
        showToaster(
          {
            texto: "Error al obtener centros de laboratorio.",
            tipo: "danger",
          },
          "centroArriba",
        )(toasterDispatch);
      }
    })(laboGrupoDispatch);
  };

  const volver = () => {
    setPaso("Home")(pasoDispatch);
  };

  const verTurnos = () => {
    history.push("/proximosTurnos");
  };

  const refreshOrdenes = () => {
    setLoading(true);
    wsGetOrdenDigitalEstudio(nextStepOrdenes)(ordenDigitalDispatch);
  };

  const nextStep = (isCorrect, data, item) => {
    if (isCorrect) {
      if (item?.requiereTurno) {
        setPaso("NumeroAfiliado")(pasoDispatch);
      } else {
        sessionStorage.setItem("flgOrdenDigital", true);
        history.push("/estudios");
      }
    } else {
      showToaster(
        {
          texto: "Error al obtener grupos de estudio.",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
    }
    setLoadingPDF(false);
  };

  const nextStepTurnoLabo = (isCorrect, data, dataCentros) => {
    if (isCorrect) {
      let centros = [
        ...(turnosDisponiblesState.turnosDisponibles?.turnosData?.filtrosData
          ?.centrosLabo ?? []),
        ...dataCentros,
      ];
      if (centroQR === null || centroQR === undefined) {
        showToaster(
          {
            texto: "Error al obtener centro, vuelva a escanear el QR.",
            tipo: "danger",
          },
          "centroArriba",
        )(toasterDispatch);
      } else {
        sessionStorage.setItem("flgOrdenDigital", true);

        let turnoByCentro = (data?.data ?? []).filter((turno) =>
          mismoCentro(turno.idCentro, centroQR),
        );
        if (turnoByCentro.length === 0) {
          showToaster(
            {
              texto: "No hay turnos disponibles para el centro seleccionado.",
              tipo: "danger",
            },
            "centroArriba",
          )(toasterDispatch);
        } else {
          let descEstudio = "TURNO DE LABORATORIO GENERAL";
          editaTurnosDisponibles({
            ...(turnosDisponiblesState.turnosDisponibles?.turnosData ?? {}),
            turnos: turnoByCentro,
            grupoMedico: 5,
            particular: false,
            idEstudio: 5,
            descEstudio: descEstudio,
            descEspecialidad: null,
            fechaBusqueda: data.fechaBusqueda,
            dtoBusqueda: { idGrupo: 5 },
            volverOrigen: "LABORATORIOQR",
            proceso: "labo",
            filtrosData: {
              ...(turnosDisponiblesState.turnosDisponibles?.turnosData
                ?.filtrosData ?? {}),
              centrosLabo: centros,
            },
          })(turnosDisponiblesDispatch);
          history.push("/turnosDisponibles");
          sessionStorage.removeItem("getOrdenes");
          sessionStorage.removeItem("ordenesList");
        }
      }
    } else {
      showToaster(
        {
          texto: "Error al obtener grupos de laboratorio.",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
    }
    setLoadingPDF(false);
  };

  const nextStepOrdenes = (isCorrect, data) => {
    if (isCorrect) {
      wsGetLabOrdenDigital((isCorrect, dataLabo) =>
        nextStepLabo(isCorrect, data, dataLabo),
      )(labOrdenDigitalDispatch);
    } else {
      setLoading(false);
      showToaster(
        {
          texto: "Error al obtener ordenes digitales.",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
    }
  };

  const nextStepLabo = (isCorrect, data, dataLabo) => {
    if (isCorrect) {
      sessionStorage.setItem("getOrdenes", true);
      let noAtendidos = (data ?? []).filter((item) => item.atendido !== true);
      let noAtendidosLabo = (dataLabo ?? []).filter(
        (item) => item.idEstado === 3 || item.idEstado === 4,
      );

      let ordenesConcat = [...noAtendidos, ...noAtendidosLabo];
      let ordenByFecha = ordenesConcat.sort((a, b) => {
        const fechaA = a.fechaAlta || a.fechaalta;
        const fechaB = b.fechaAlta || b.fechaalta;
        return new Date(fechaB).getTime() - new Date(fechaA).getTime();
      });
      setOrdenesList(ordenByFecha);
      setLoading(false);
      sessionStorage.setItem("ordenesList", JSON.stringify(ordenByFecha));
    } else {
      setLoading(false);
      showToaster(
        {
          texto: "Error al obtener ordenes de laboratorio.",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
    }
  };

  const checkTurnoTomado = (element) => {
    const esLabo = element?.idprotocolo;

    if (!esLabo) {
      if (element.idTurno !== null) {
        return true;
      } else {
        return false;
      }
    } else {
      if (element.idLabProtAgenda !== 0) {
        return true;
      } else {
        return false;
      }
    }
  };

  // -------------------------  funciones  ----------------------------

  // -------------------------  useEffect  ----------------------------
  useEffect(() => {
    if (getOrdenes === null) {
      // wsGetOrdenesDigitalesById(authState.auth.data.paciente.codigo, nextStep);
      wsGetOrdenDigitalEstudio(nextStepOrdenes)(ordenDigitalDispatch);
    } else {
      let ordenes = getSessionStorage("ordenesList");
      setLoading(false);
      setOrdenesList(ordenes);
    }
  }, []);
  // -------------------------  useEffect  ----------------------------

  return (
    <>
      <Loading
        dataLoading={loading || loadingPDF}
        color="c-white"
        descripcion={"Cargando..."}
      />
      <RefreshBox>
        <button
          onClick={() => refreshOrdenes()}
          style={{
            backgroundColor: "#ffffff",
            border: "2px solid var(--color-latex30)",
            borderRadius: "50%",
            width: "36px",
            height: "36px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
          className="spin"
        >
          <FaSyncAlt size={20} color="var(--color-latex30)" />
        </button>
      </RefreshBox>
      <LayoutPasos
        volverTo={"/autocheckin"}
        handleClick={volver}
        title={"ÓRDENES PARA ESTUDIOS MÉDICOS"}
        subtitle={
          "Éstas son las órdenes digitales que tu médico indicó para que puedas sacar turno."
        }
      >
        {!loading && (
          <ContainerP5
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 100 }}
            transition={{ duration: 0.4 }}
          >
            <BodyContainerP5 className="ordenes-scroll-body">
              {ordenesList?.length > 0 ? (
                ordenesList.map((element, index) => {
                  // Flags de validez de la orden devueltos por el back:
                  //   enEspera: la orden todavía no entró en vigencia (validez a futuro).
                  //   vencida: la orden está fuera del plazo de validez de la OS.
                  // En ambos casos ocultamos el botón de acción y mostramos un
                  // mensaje informativo. Si el paciente ya tomó turno con la orden,
                  // ese estado gana y mostramos "Ver detalles del turno".
                  const tieneTurnoTomado = checkTurnoTomado(element);
                  const esOrdenFutura = !!element?.enEspera;
                  const esOrdenVencida = !!element?.vencida;
                  const fechaValidezOrigen =
                    element?.fecha || element?.fechaalta;
                  const fechaValidezFormatted =
                    esOrdenFutura && fechaValidezOrigen
                      ? new Date(fechaValidezOrigen).toLocaleDateString(
                          "es-AR",
                          {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                          },
                        )
                      : null;
                  return (
                    <CardOrden key={index}>
                      <p className="header rb18m">
                        {element?.idprotocolo
                          ? "Laboratorio"
                          : element?.idGrupoEstudioDesc === null
                            ? "Estudio"
                            : camelize(element?.idGrupoEstudioDesc)}
                      </p>
                      <div className="bodyOrden">
                        <p>
                          Emitida el:{" "}
                          <span className="rb16m">
                            {new Date(
                              element?.fechaAlta || element?.fechaalta,
                            ).toLocaleDateString("es-AR")}
                          </span>
                        </p>
                        <p>
                          Médico:{" "}
                          <span className="rb16m">
                            {element?.idUsuarioAltaDesc}
                          </span>
                        </p>
                        {!idTerminal && (
                          <div
                            className="btnOrdenPdf rb14m"
                            onClick={() => handleClickButton(element)}
                          >
                            <PdfIcon /> Ver Orden
                          </div>
                        )}

                        {tieneTurnoTomado ? (
                          <ButtonP5
                            className="rb16m"
                            $tieneTurno={true}
                            onClick={() => verTurnos()}
                          >
                            Ver detalles del turno
                          </ButtonP5>
                        ) : esOrdenFutura ? (
                          <p
                            className="rb16l c-latex30"
                            style={{ textAlign: "center" }}
                          >
                            Esta orden tiene validez desde{" "}
                            {fechaValidezFormatted}
                          </p>
                        ) : esOrdenVencida ? (
                          <p
                            className="rb16l c-latex30"
                            style={{ textAlign: "center" }}
                          >
                            Orden vencida — fuera del plazo de validez de su
                            obra social
                          </p>
                        ) : (
                          <ButtonP5
                            className="rb16m"
                            $tieneTurno={false}
                            onClick={
                              element?.idprotocolo
                                ? () => asociarTurnoLabo(element)
                                : () => verAgendasDisponibles(element)
                            }
                          >
                            {!element?.requiereTurno
                              ? "Solicitar turno"
                              : "Atenderme ya"}
                          </ButtonP5>
                        )}
                      </div>
                    </CardOrden>
                  );
                })
              ) : (
                <ContainerSinTurno>
                  <AlertIconFilled
                    height={"70"}
                    width={"70"}
                    color={"var(--color-latex10)"}
                  />
                  <span className="title">
                    No se encontraron órdenes digitales
                  </span>
                </ContainerSinTurno>
              )}
            </BodyContainerP5>
            <ScrollArrows targetSelector=".ordenes-scroll-body" />
          </ContainerP5>
        )}
      </LayoutPasos>
    </>
  );
};

export default OrdenesDigitales;
